import { useCallback, useMemo } from "react";
import { useLivePreview } from "@payloadcms/live-preview-react";
import { getPayloadCmsUrl } from "src/api/payload/client";
import { mapEgdGame } from "src/utils/mapEgdGame";
import { egdLivePreviewRequestHandler } from "src/utils/egdLivePreviewHandler";
import { isPayloadEgdSource } from "src/utils/egdSource";

/**
 * Live preview for a single EGD game card (admin iframe on /gaming-machines/egd-games/preview).
 *
 * @param {string} [locale] - `en` | `fr`
 */
export function useEgdGameCardLivePreview(locale) {
  const enabled = isPayloadEgdSource();
  const initialDoc = useMemo(() => ({}), []);
  const requestHandler = useCallback(egdLivePreviewRequestHandler, []);

  const { data: liveDoc, isLoading } = useLivePreview({
    initialData: initialDoc,
    serverURL: getPayloadCmsUrl(),
    depth: 1,
    requestHandler,
  });

  const game = useMemo(() => {
    if (!enabled || !liveDoc?.key) return null;
    return mapEgdGame(liveDoc, locale);
  }, [enabled, liveDoc, locale]);

  return {
    game,
    isLoading: enabled && isLoading,
    isLivePreview: Boolean(liveDoc?.key),
  };
}
